import { Vue, Component, Watch } from 'vue-property-decorator'
import { Item } from 'src/graphql/types'

@Component
export default class ItemMixinAncesstors extends Vue {
  pathItem: Item | null = null

  @Watch('item', { immediate: true })
  init (item: Item) {
    this.pathItem = item
  }

  get ancesstors () {
    const ancesstors = []
    if (this.pathItem?.path) {
      const itemAncesstorsNames = [...(this.pathItem.ancesstors || [])]
      const itemAncesstorsIds = this.pathItem.path.split('.').reverse().slice(1, itemAncesstorsNames.length + 1).reverse()
      while (itemAncesstorsIds.length && itemAncesstorsNames.length) {
        let id = itemAncesstorsIds.shift()
        let name = itemAncesstorsNames.shift()
        ancesstors.push({ id, name })
      }
    }
    return ancesstors
  }

  get parent () {
    return [...this.ancesstors].pop()
  }

  get grandparents () {
    return [...this.ancesstors].slice(0, -1)
  }
}
